import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { Card, Badge, EmptyState, InlineStack, Icon, Modal, Scrollable, SkeletonBodyText, Text, Tooltip, BlockStack, Button } from '@shopify/polaris';
import { NoteMinor } from '@shopify/polaris-icons';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png';
import { Table } from 'antd';
import { LastFeedActivitiesCols } from '../Utilities/Constants';
import { stringWithTooltip } from '../../Function';
import { columns } from '../../NewProductImport/Utils/Constants';
import { useTranslation } from 'react-i18next';

interface props extends DIProps {
    row: any
    lastActivities: any
    setLastActivities: (data: any) => void
}

const ActivityFeeds = (props: props) => {
    const { t } = useTranslation();
    const { row } = props;
    const [active, setActive] = useState<boolean>(false);
    const [lastActivities, setLastActivities] = useState<any>({})
    const [modalLoader, setModalLoader] = useState<boolean>(true);

    useEffect(() => {
        if (active) {
            if (!Object.keys(lastActivities).includes(row?.items?.source_product_id))
                getProduct();
        }
    }, [active])

    const formattedDate = (date: any) => {
        const inputDateTime = new Date(date);
        const date_1 = inputDateTime.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
        const time = inputDateTime.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        const day = inputDateTime.getDate();
        const ordinalDay = getOrdinalSuffix(day);

        return (
            <BlockStack gap="100" inlineAlign='start'>
                <Text as='span'>{ordinalDay + " " + date_1}</Text>
                <Text as='span'>{time}</Text>
            </BlockStack>
        );
    }

    const getOrdinalSuffix = (day: any) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
            case 1:
                return `${day}st`;
            case 2:
                return `${day}nd`;
            case 3:
                return `${day}rd`;
            default:
                return `${day}th`;
        }
    }

    const customWidth = (key: string) => {
        switch (key) {
            case "feed_product_type":
                return "120px"
            case "item_sku":
                return "120px"
            case "item_name":
                return '100px'
            case "external_product_id":
                return '150px'
            case 'recommended_browse_nodes':
                return '180px'
            case 'binding':
                return '100px'
            case 'manufacturer':
                return '100px'
            case 'author1':
                return '80px'
            case "publication_date":
                return '100px'
            case "language_published":
                return '120px'
            case 'country_of_origin':
                return "120px"
            case 'standard_price':
                return "100px"
            case 'quantity':
                return "60px"
            case 'maximum_retail_price':
                return "140px"
            case "main_image_url":
                return "100px"
            case "update_delete":
                return "100px"
            case "product_description":
                return "250px";
            case "barcode_exemption":
                return '120px'
            case "barcode_exemption":
                return "100px"
            case "category":
                return "80px"
            case 'sub_category':
                return "100px"
            case "fulfillment_centre_id":
                return "120px"
            case "variation_theme":
                return "150px"
            case 'main_image_url':
                return '120px'
            case 'other_image_url1':
                return '100px'
            case 'other_image_url2':
                return '100px'
            case 'other_image_url3':
                return '100px'
            case 'other_image_url4':
                return '100px'
            case 'other_image_url5':
                return '100px'
            case 'other_image_url6':
                return '100px'
            default:
                return "150px"
        }
    }

    function flattenJson(data: any, parentKey: string = '', sep: string = '_') {
        let result: any = {};
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                let newKey = parentKey ? `${parentKey}${sep}${key}` : key;
                // Flatten the object or array
                if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] !== null) {
                    Object.assign(result, flattenJson(data[key], newKey, sep));
                } else if (Array.isArray(data[key])) {
                    data[key].forEach((item: any, index: any) => {
                        Object.assign(result, flattenJson({ [`${key}_${index}`]: item }, parentKey, sep));
                    });
                } else {
                    result[newKey] = data[key];
                }
            }
        }
        // Remove trailing zeros from keys
        let cleanedResult: any = {};
        for (let key in result) {
            if (result.hasOwnProperty(key)) {
                let cleanedKey = key.replace(/_0(?=_|$)/g, '');
                cleanedResult[cleanedKey] = result[key];
            }
        }
        return cleanedResult;
    }


    const formatGridData = (columns: any, data: any) => {
        let tempArr: any = [];
        data?.map((dataObj: any) => {
            dataObj = flattenJson(dataObj)
            let obj: any = {};
            Object.keys(dataObj).forEach((key: any) => {
                columns?.map((cols: any, id: number) => {
                    if (cols?.dataIndex == 'updated_at')
                        obj[cols?.dataIndex] = dataObj[cols?.dataIndex] ? formattedDate(dataObj[cols?.dataIndex]) : 'N/A';
                    else if (cols?.dataIndex == 'status')
                        obj[cols?.dataIndex] = dataObj[cols?.dataIndex] ? <Badge>{dataObj[cols?.dataIndex]?.replace("_", " ")}</Badge> : 'N/A';
                    else if (cols?.dataIndex == "product_description") {
                        obj[cols?.dataIndex] = dataObj[cols?.dataIndex] ? <LargeContentReadMore key={key} title={cols?.dataIndex} desc={dataObj[cols?.dataIndex]?.replace("_", " ")} /> : 'N/A';
                    }
                    else if (cols?.dataIndex == "main_image_url") {
                        obj[cols?.dataIndex] = dataObj[cols?.dataIndex] ? <Text as='span'>{stringWithTooltip(dataObj[cols?.dataIndex]?.replace("_", " "), 70)}</Text> : 'N/A';
                    }
                    // else if(cols?.dataIndex == "purchasable_offer"){
                    //     console.log("Purchasable_offer")
                    // }
                    else obj[cols?.dataIndex] = <LargeContentReadMore key={key} title={cols?.dataIndex} desc={dataObj[cols?.dataIndex]?.toString()} /> || 'N/A';
                })
            })
            tempArr?.push(obj)
        })
        return tempArr;
    }

    const formatKey = (key: any) => {
        return key
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char: any) => char.toUpperCase());
    };



    const formatColumns = (data: any) => {
        let tempCols: any = [...LastFeedActivitiesCols(t)];
        let obj: any = {};
        data?.forEach((key: any) => {
            let activity = flattenJson(key.data)
            Object.keys(activity)?.forEach((key1: any) => {
                obj[key1] = {
                    "title": formatKey(key1),
                    "dataIndex": key1,
                    "key": key1,
                    'width': customWidth(key1),
                }
            })
        })
        tempCols?.push(...Object.values(obj))
        return tempCols;
    }

    const formatRows = (data: any) => {
        let tempArr: any = [];
        data?.map((keys: any) => {
            let obj: any = {};
            obj = { ...keys, ...keys?.data }
            delete obj['data']
            tempArr?.push(obj);
        })
        return tempArr;
    }


    const getProduct = async () => {
        let temp = { ...lastActivities };
        let { source, target } = props.redux.current;
        let params: any = {
            target_marketplace: target?.marketplace,
            source_marketplace: source?.marketplace,
            sourceShopID: source._id,
            targetShopID: target._id,
            source_product_id: row?.items?.source_product_id
        };
        await props.di.GET("connector/product/getProduct", params)
            .then((response: any) => {
                setModalLoader(false);
                if (response?.success) {
                    response?.data?.rows && response?.data?.rows?.map((editedRow: any, idx: number) => {
                        if (editedRow?.edited && editedRow?.edited?.last_activities) {
                            editedRow?.edited?.last_activities?.map((activity: any, index: number) => {


                                let tempCols: any = formatColumns(editedRow?.edited?.last_activities?.filter((data: any) => data?.type === activity?.type));

                                let tempRows: any = formatRows(editedRow?.edited?.last_activities?.filter((data: any) => data?.type === activity?.type));
                                if (activity?.type) {
                                    temp[row?.items?.source_product_id] = {
                                        ...temp[row?.items?.source_product_id],
                                        [activity.type]: {
                                            columns: tempCols,
                                            rows: formatGridData(tempCols, tempRows)
                                        }
                                    }
                                }
                            })
                        }
                        else {
                            delete temp[row?.items?.source_product_id]
                        }
                    })
                }
                else {
                    props.error(t(response?.message))
                    delete temp[row?.items?.source_product_id]
                }

                setLastActivities({ ...temp })
            })
    }


    const renderModalContent = useCallback(() => {
        let render: any = <></>;
        let renderErr: any = <InlineStack gap="400" align="center">
            <EmptyState
                image={NoResultsFound}
                heading={t("No Feeds Found")}
            />
        </InlineStack>;


        if (Object.keys(lastActivities).length > 0) {
            if (Object.keys(lastActivities).includes(row?.items?.source_product_id)) {
                Object.keys(lastActivities).map((id: string, idx: number) => {
                    render = (
                        <BlockStack gap="200">
                            {
                                Object.keys(lastActivities[row?.items?.source_product_id]).map((key: any, index: number) => {
                                    return (

                                        <Card padding="400" key={index + idx}>
                                            <BlockStack gap="300">
                                                <div>
                                                    <InlineStack align="start">
                                                        <Text as="span" fontWeight="semibold">{key.charAt(0).toUpperCase() + key.slice(1)}</Text>
                                                    </InlineStack>
                                                </div>
                                                <Table
                                                    columns={lastActivities[row?.items?.source_product_id][key]['columns']}
                                                    dataSource={lastActivities[row?.items?.source_product_id][key]['rows']}
                                                    pagination={false}
                                                    size="middle"
                                                    scroll={{ x: 5000 }}
                                                />
                                            </BlockStack>
                                        </Card >
                                    );
                                })
                            }
                        </BlockStack>
                    )
                })
            }
            else render = renderErr;

        }
        else render = renderErr;
        return render;
    }, [lastActivities])

    return (
        <React.Fragment>
            <div onClick={() => setActive(!active)} style={{ cursor: 'pointer' }}>
                <Tooltip dismissOnMouseOut content={t("Activity Feed")}>
                    <Icon
                        source={NoteMinor}
                        tone="subdued"
                    />
                </Tooltip>
            </div>
            <Modal
                open={active}
                onClose={() => setActive(!active)}
                title={t("Recent Feed Activities")}
                size="large"
                primaryAction={{
                    content: 'Close',
                    onAction: () => setActive(!active),
                }}
            >
                <Modal.Section>
                    <Scrollable>
                        {modalLoader ? <SkeletonBodyText /> : <BlockStack gap="400"> {renderModalContent()} </BlockStack>}
                    </Scrollable>
                </Modal.Section>
            </Modal>
        </React.Fragment>
    );
}

const LargeContentReadMore = ({ desc, title }: any) => {
    const [modalOpen, setModalOpen] = useState(false);

    // Function to close modal
    const handleModalClose = useCallback(() => {
        setModalOpen(false);
    }, []);
    return (<>{
        desc ? desc?.length < 80 ? desc || "N/A" : <InlineStack>
            <Text as='p'>{desc?.slice(0, 80) + "..."}</Text>
            <Button variant='plain' onClick={() => setModalOpen(!modalOpen)}>Show Full</Button>
        </InlineStack> : "N/A"
    }
        <Modal
            open={modalOpen}
            onClose={handleModalClose}

            title={title?.replace("_", " ")}        >
            <Modal.Section>
                <Text as='p'>{desc}</Text>
            </Modal.Section></Modal>

    </>)
}

export default DI(ActivityFeeds)